import React, { ComponentProps } from 'react';
import { FormattedMessage } from '@kyruus/intl';
import { ProviderMatchContact } from '@kyruus/types';
import Link from '@kyruus/link';

import { MarketableLocationUrl, Log } from 'Src/types';
import { getEmail, getFax, getPhone, getWebsiteUrl } from 'Src/utils/location';
import messages from '../messages';
import { ContactItem, ContactItemTitle, ContactList } from './styles';
import { LOGGING_EVENTS } from '../constants';

interface BaseContactsProps {
  contacts?: ProviderMatchContact[];
  urls?: MarketableLocationUrl[];
  log: Log;
}

type ContactsProps = BaseContactsProps & ComponentProps<'ul'>;

export const Contacts = ({
  contacts = [],
  urls = [],
  log,
  ...props
}: ContactsProps) => {
  const websiteUrl = getWebsiteUrl(urls);
  const phone = getPhone(contacts);
  const email = getEmail(contacts);
  const fax = getFax(contacts);

  if (!websiteUrl && !phone && !email && !fax) {
    return null;
  }

  return (
    <ContactList {...props}>
      {phone && (
        <ContactItem>
          <FormattedMessage
            {...messages.labelPhone}
            tagName={ContactItemTitle}
          />
          <Link
            data-testid="PhoneLink"
            href={`tel:${phone}`}
            onClick={() => {
              log(LOGGING_EVENTS.CLICK_LOCATION_PHONE);
            }}
          >
            {phone}
          </Link>
        </ContactItem>
      )}
      {websiteUrl?.href && (
        <ContactItem>
          <FormattedMessage
            {...messages.labelWebsite}
            tagName={ContactItemTitle}
          />
          <Link
            data-testid="WebsiteLink"
            rel="noopener noreferrer"
            target="_blank"
            href={websiteUrl.href}
            onClick={() => log(LOGGING_EVENTS.CLICK_LOCATION_WEBSITE_LINK)}
          >
            {websiteUrl.display}
          </Link>
        </ContactItem>
      )}
      {email && (
        <ContactItem>
          <FormattedMessage
            {...messages.labelEmail}
            tagName={ContactItemTitle}
          />
          <Link
            data-testid="EmailLink"
            href={`mailto:${email}`}
            onClick={() => {
              log(LOGGING_EVENTS.CLICK_LOCATION_EMAIL_LINK);
            }}
          >
            {email}
          </Link>
        </ContactItem>
      )}
      {fax && (
        <ContactItem>
          <FormattedMessage {...messages.labelFax} tagName={ContactItemTitle} />
          <span>{fax}</span>
        </ContactItem>
      )}
    </ContactList>
  );
};
